import NAME from "./constants";

export const loading = store => store[NAME].loading;
export const getGeneralSettings = store => store[NAME].generalSettings;